var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "m15 14l4-4l-4-4" }),
      createElementVNode("path", { d: "M19 10H8a4 4 0 1 0 0 8h1" })
    ], -1)
  ]));
}
__name(render, "render");
const arrowForwardUp = markRaw({ name: "tabler-arrow-forward-up", render });
export {
  arrowForwardUp as default
};
//# sourceMappingURL=arrow-forward-up.js.map
